import script from "./LitigationMembersListModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LitigationMembersListModal.vue?vue&type=script&setup=true&lang=ts"

import "./LitigationMembersListModal.vue?vue&type=style&index=0&id=2ea81ef3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea81ef3"]])

export default __exports__